import React from "react";

function ContactHeader() {
  return (
    <>
      <header className="contact-header">
        <div className="header-text">
          <h2>contact me</h2>
          <p>Hi there, contact me to ask me about anything you have in mind.</p>
        </div>
      </header>
    </>
  );
}

export default ContactHeader;
